import { render, staticRenderFns } from "./RepVenta.vue?vue&type=template&id=7239cb2b&"
import script from "./RepVenta.vue?vue&type=script&lang=js&"
export * from "./RepVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports